import ModalSlot, { slot } from "../../components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3014420-651dc65241c1f.png"

const links = [...slot(11, {space: 7.1, init: 10.7, height: 6.3}), {
    width: "28.4%",
    height: "4.8%",
    top: "89.7%",
    left: "34.8%"
}]

const slots = [
    {
        href: "https://www.isflive.org/s/article/IRAM2-WebApp",
        label: "IRAM2 Methodology and WebApp Update"
    },
    {
        href: "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology-Assistant",
        label: "QIRA Assistant"
    },
    {
        href: "https://www.isflive.org/s/article/vulnerability-management-beyond-patching",
        label: "Vulnerability Management: Beyond patching"
    },
    {
        href: "https://www.isflive.org/s/article/securing-operational-machine-learning-systems",
        label: "Securing Operational machine learning systems"
    },
    {
        href: "https://www.isflive.org/s/article/Demystifying-Artificial-Intelligence-in-Information-Security",
        label: "Demystifying Artificial Intelligence in Information Security"
    },
    {
        href: "https://www.isflive.org/s/article/Demystifying-Zero-Trust-Briefing-Paper?topicId=0TO0J0000009AO5WAM",
        label: "Demystifying Zero Trust"
    },
    {
        href: "https://www.isflive.org/s/article/Threat-Intelligence-react-and-prepare",
        label: "Threat Intelligence react and prepare"
    },
    {
        href: "https://www.isflive.org/s/article/Embedding-Security-into-Agile-Development-Ten-principles-for-rapid-improvement-Report",
        label: "Embedding-Security-into-Agile-Development-Ten-principles-for-rapid-improvement-Report".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/Cyber-Insurance-Is-it-worth-the-risk",
        label: "Cyber-Insurance-Is-it-worth-the-risk".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/Extinction-Level-Attacks-A-survival-guide-Report?topicId=0TO0J0000001zfJWAQ",
        label: "Extinction Level Attacks: A survival guide report"
    },
    {
        href: "https://www.isflive.org/s/article/Securing-Containers-Keeping-pace-with-change-Briefing-paper",
        label: "Securing-Containers-Keeping-pace-with-change-Briefing-paper".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/knowledge-library",
        label: "Visit the ISF Library"
    }
]

export default () => <ModalSlot img={image} links={links} slots={slots} />